import Api from './Api'
import Resource from './Resource'

export { Resource, Api as Resources }

export default Api
